import { VenueVideoBoardsComponent } from './venue-video-boards/venue-video-boards.component';
import { VenueIntegrationsComponent } from './venue-integrations/venue-integrations.component';
import { VenueAdminsComponent } from './venue-admins/venue-admins.component';
import { VenueCourtsComponent } from './venue-courts/venue-courts.component';
import { Routes } from '@angular/router';
import { VideoBoardSettingsComponent } from './video-board-settings/video-board-settings.component';

export const venueDetailsRoutes: Routes = [
    {
      path: '',
      children: [
        {
          path: 'courts',
          component: VenueCourtsComponent
        },
        {
          path: 'integrations',
          component: VenueIntegrationsComponent
        },
        {
          path: 'video-boards',
          children: [
          {
            path: '',
            redirectTo: 'my-scoreboards',
            pathMatch: 'full'
          },
          {
            path: 'my-scoreboards',
            component: VenueVideoBoardsComponent
          },
          {
            path: 'settings',
            component: VideoBoardSettingsComponent
          }
          ]
        },
        {
          path: 'admins',
          component: VenueAdminsComponent
        },
        {
          path: '**',
          redirectTo: 'courts'
        },
        {
          path: '**',
          redirectTo: ''
        }
      ],
    },
  ];